import { render, staticRenderFns } from "./MobileNavbar.vue?vue&type=template&id=4984b552&scoped=true&"
import script from "./MobileNavbar.vue?vue&type=script&lang=js&"
export * from "./MobileNavbar.vue?vue&type=script&lang=js&"
import style0 from "./MobileNavbar.vue?vue&type=style&index=0&id=4984b552&prod&scoped=true&lang=css&"
import style1 from "./MobileNavbar.vue?vue&type=style&index=1&id=4984b552&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4984b552",
  null
  
)

export default component.exports